import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { TicketService } from '../core/services/ticket/ticket.service';
import { Subject } from 'rxjs/internal/Subject';
import { ReplyService } from '../core/services/ticket/reply.service';
import { ForwardEntityTypeEnum } from '../core/enums/forward-entity-type.enum';
import { AttachmentOwnerType } from '@sb-tools/typescript/enums/attachment-owner-type.enum';
import { ForwardTicket } from '../core/models/forward-ticket.model';
import { DetailedTicketDTO } from '../core/models/dto/detailed-ticket.dto';
import { LoaderComponent } from '../../sb-tools/typescript/components/loader/loader.component';
import { ForwardMessageModalComponent } from '../shared/modal-windows/forward-message-modal/forward-message-modal.component';

@Component({
    selector: 'app-forward-ticket',
    templateUrl: './forward-ticket.component.html',
    styleUrls: ['./forward-ticket.component.scss'],
    imports: [LoaderComponent, ForwardMessageModalComponent],
})
export class ForwardTicketComponent implements OnInit {
    forwardTicketData: ForwardTicket;
    isLoaded: boolean;

    private attachmentUrl: string;
    private entityType: ForwardEntityTypeEnum;
    private ownerId: number;
    private ownerType: number;
    private replyId: number;
    private ticket: DetailedTicketDTO;
    private ticketId: number;
    private unsubscriber = new Subject<void>();

    constructor(
        private activatedRoute: ActivatedRoute,
        private ticketService: TicketService,
        private replyService: ReplyService,
    ) {}

    ngOnInit(): void {
        if (
            this.activatedRoute.snapshot.queryParams['ticketId'] &&
            this.activatedRoute.snapshot.queryParams['ticketId'] !== 'undefined'
        ) {
            this.ticketId = +this.activatedRoute.snapshot.queryParams['ticketId'];
            this.entityType = +this.activatedRoute.snapshot.queryParams['forwardType'];
            this.replyId = +this.activatedRoute.snapshot.queryParams['replyId'];
            this.attachmentUrl = this.activatedRoute.snapshot.queryParams['attachmentUrl'];
            this.ownerId = +this.activatedRoute.snapshot.queryParams['ownerId'];
            this.ownerType = +this.activatedRoute.snapshot.queryParams['ownerType'];

            this.loadTicket(this.ticketId);
        }
    }

    private getForwardEntityData() {
        switch (this.entityType) {
            case ForwardEntityTypeEnum.reply: {
                return this.replyService.findReply(this.ticket.messageThread, this.replyId);
            }
            case ForwardEntityTypeEnum.ticketMessage: {
                return {
                    ticketId: this.ticket.id,
                    id: this.ticket.id,
                    message: this.ticket.message,
                    attachments: this.ticket.attachments,
                };
            }
            case ForwardEntityTypeEnum.attachment: {
                let attachment;

                if (this.ownerType === AttachmentOwnerType.ticket) {
                    attachment = this.ticket.attachments.find((ticketAttachment) => {
                        return ticketAttachment.url === this.attachmentUrl;
                    });
                } else {
                    const reply = this.replyService.findReply(this.ticket.messageThread, this.ownerId);

                    if (reply) {
                        attachment = reply.attachments.find((replyAttachment) => {
                            return replyAttachment.url === this.attachmentUrl;
                        });
                    }
                }
                return { message: {}, attachments: [attachment] };
            }
            default:
                return this.ticket;
        }
    }

    private initForwardMessageData() {
        this.forwardTicketData = {
            entity: this.getForwardEntityData(),
            entityType: this.entityType,
            currentTicket: this.ticket,
        };
    }

    private loadTicket(ticketId) {
        this.ticketService
            .get(ticketId)
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((ticket) => {
                this.ticket = ticket;
                this.initForwardMessageData();
                this.isLoaded = true;
            });
    }
}
